var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { class: ["tx-market-badge", `tx-market-badge--${_vm.market.kind}`] },
    [
      _vm.market.kind === "total"
        ? [_vm._m(0), _c("strong", [_vm._v(_vm._s(_vm.market.value))])]
        : _vm._l(_vm.market.faces, function (face, index) {
            return _c("img", {
              key: index,
              staticClass: "tx-market-badge__die",
              attrs: { src: _vm.diceImage(face), alt: `Die ${face}` },
            })
          }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "i",
      {
        staticClass: "tx-market-badge__dots",
        attrs: { "aria-hidden": "true" },
      },
      [_c("b"), _c("b"), _c("b")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }